import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';

import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 262,
  },
  icon: {
    marginLeft: theme.spacing(1),
    height: theme.spacing(2.25),
    width: theme.spacing(2.25),
    color: theme.palette.success.main,
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center',
    userSelect: 'none',
  },
  checkedColor: {
    color: theme.palette.primary.main,
  },
  subText: {
    paddingLeft: theme.spacing(4),
    color: theme.palette.text.secondary,
    userSelect: 'none',
    marginBottom: theme.spacing(1),
  },
}));

function ReviewedSection({
  selected,
  setSelected,
  className,
}: {
  selected: boolean;
  setSelected: (value: boolean) => void;
  className?: string;
}) {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.column, className)}>
      <FormControl component='fieldset'>
        <RadioGroup value={selected.toString()} onChange={(e) => setSelected(e.target.value === 'true')}>
          <FormControlLabel
            value='true'
            control={<Radio sx={{ py: 0 }} />}
            label={
              <div className={classNames(classes.radioLabel, selected === true && classes.checkedColor)}>
                <Typography>Reviewed</Typography>
                <CheckCircleIcon className={classes.icon} />
              </div>
            }
          />
          <Typography variant='captionRegular' className={classes.subText}>
            Transactions will be marked as reviewed.
          </Typography>

          <FormControlLabel
            value='false'
            control={<Radio sx={{ py: 0 }} />}
            label={
              <div className={classNames(classes.radioLabel, selected === false && classes.checkedColor)}>
                <Typography>Not reviewed</Typography>
              </div>
            }
          />
          <Typography variant='captionRegular' className={classes.subText}>
            Transactions will be marked as not reviewed.
          </Typography>
        </RadioGroup>
      </FormControl>
    </div>
  );
}

export default memo(ReviewedSection);
